import { createAsyncThunk } from '@reduxjs/toolkit';
import { RouteParamsType } from '../../types/utils/router-params.type';
import axios from 'axios';
import { PaginationType } from '../../types/utils/pagination.type';
import { LeadType } from '../../types/leads/lead.type';
import { LeadLogType } from '../../types/leads/lead-log.type';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';

export const getLeadsList = createAsyncThunk(
  'leads/getLeadsList',
  async (data: RouteParamsType & { controller: AbortController }, thunkAPI) => {
    try {
      const { controller, ...params } = data;
      const response = await axios.get<PaginationType<LeadType>>(`${process.env.REACT_APP_API_URL}/leads`, {
        params,
        ...(controller ? { signal: controller.signal } : {}),
      });
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error during leads fetching!' });
    }
  }
);

export const getLeadLogsList = createAsyncThunk<
  PaginationType<LeadLogType>,
  RouteParamsType & { controller: AbortController },
  { state: RootReducerState }
>('leads/getLeadLogsList', async (data: RouteParamsType & { controller: AbortController }, thunkAPI) => {
  try {
    const { controller, ...params } = data;
    const response = await axios.get<PaginationType<LeadLogType>>(`${process.env.REACT_APP_API_URL}/prm-crm-bridge`, {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    });
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error during lead logs fetching!' });
  }
});
